import type { JSX } from 'react';

import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { DetailsContainer } from '../containers/Details';
import { useIsSunriseEnabled } from '../hooks/isSunriseEnabled';
import { useShowSurvey } from '../hooks/useShowSurvey';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();
	useShowSurvey();

	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
			<DetailsContainer />{' '}
		</DesignSystemLegacy>
	);
}
